import React from 'react'

import { ArticleList, type ArticleListProps } from '@components/common'

import { SectionTitle } from '../SectionTitle'

export type ArticleListSectionProps = {
  title: string
  articleList: ArticleListProps
}

export const ArticleListSection = ({ title, articleList }: ArticleListSectionProps) => (
  <div>
    <SectionTitle title={title} />
    <div>
      <ArticleList {...articleList} />
    </div>
  </div>
)
